import { useEffect, useState } from 'react';
import axios from 'axios';

let cache = null;
let inflight = null;
const listeners = new Set();

export const refreshStoreSettings = () => {
  inflight = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/store`)
    .then(({ data }) => { cache = data; listeners.forEach(fn => fn(data)); return data; })
    .catch(() => cache)
    .finally(() => { inflight = null; });
  return inflight;
};

export const useStoreSettings = () => {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    if (!cache && !inflight) refreshStoreSettings();
    return () => { listeners.delete(setData); };
  }, []);
  return data;
};
